import React from "react";
import type { OnChangeValue } from "react-select";

import cx from "classnames";

import { type Channel, type ChannelNode, ZoomChannelSelect } from "~/common/ZoomChannelSelect";

import stylesMeetingReminders from "~/stream/StreamSettings/Automations/MeetingReminders.module.css";
import stylesTimeSaver from "~/stream/StreamSettings/Automations/TimeSaver.module.css";

import styles from "./Slack.module.css";

interface Props {
	channel: ChannelNode;
	onChange: (v: ChannelNode) => void;
}

export default function ZoomInputs({ channel, onChange: _onChange }: Props) {
	const value = React.useMemo(() => {
		if (channel.id) {
			return { ...channel, label: channel.name, value: channel.name };
		}

		return undefined;
	}, [channel]);

	const onChange = React.useCallback(
		(v: OnChangeValue<Channel, false>) => {
			if (v) {
				_onChange({ id: v.id, name: v.name, isUser: v.isUser });
			}
		},
		[_onChange],
	);

	return (
		<>
			<label
				className={cx(
					stylesMeetingReminders.row,
					stylesTimeSaver.row,
					stylesMeetingReminders.tight,
					stylesTimeSaver.label,
				)}
			>
				Select a channel:
			</label>
			<div className={cx(stylesMeetingReminders.row, stylesTimeSaver.row, stylesMeetingReminders.tight)}>
				<ZoomChannelSelect onChange={onChange} placeholder="Zoom" className={styles.slackSelect} value={value} />
			</div>
		</>
	);
}
